import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { collection, onSnapshot, query } from "firebase/firestore";
import { db } from "../../../../firebaseConfig";
import { setPackages } from "../../../../store/commonSlice";

/**
 * Custom hook to fetch and manage packages for shipping requests
 * @returns {void}
 */
export const useShippingRequestPackages = () => {
  const dispatch = useDispatch();
  const { selectedRequest: userActiveData } = useSelector(
    (state) => state.common
  );
  const unsubscribeRef = useRef(null);

  useEffect(() => {
    try {
      const querySnapshot = collection(db, "shelfPackages");
      const q = query(querySnapshot);

      unsubscribeRef.current = onSnapshot(q, async (snapshot) => {
        const arr = [];
        snapshot.forEach((doc) => {
          arr.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        dispatch(setPackages(arr));
      });

      return () => {
        if (unsubscribeRef.current) {
          unsubscribeRef.current();
        }
      };
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  }, [dispatch]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (unsubscribeRef.current) {
        unsubscribeRef.current();
      }
    };
  }, []);
};

